import { DEFAULT_ERROR_DISPLAY_INFO } from '@/services/wbff/constants'
import { NormalizedWbffResponse, WbffError, WbffResponse } from '@/services/wbff/types'
import { request } from '@/services/wbff/utils'
import { useCommonStore } from '@/store/common'
import { AxiosRequestConfig } from 'axios'
import { f7 } from 'framework7-vue'

export const handleWbffResponse = <T>(wbffResponse: WbffResponse<T>): NormalizedWbffResponse<T> => {
  if (isSuccessWbffResponse(wbffResponse)) {
    return {
      isSuccess: true,
      payload: wbffResponse.payload as T
    }
  } else if (isMaintenanceWbffResponse(wbffResponse)) {
    setTimeout(() => {
      f7.views.current.router.navigate('/maintenance/')
    }, 0)
    return {
      isSuccess: false,
    }
  } else {
    handleWbffErrorResponse(wbffResponse)
    return {
      isSuccess: false,
      error: wbffResponse.error as WbffError
    }
  }
}

const isSuccessWbffResponse = (response: WbffResponse): boolean => {
  return response.header.resultCode === 'S0000'
}

const isMaintenanceWbffResponse = (response: WbffResponse): boolean => {
  return response.header.resultCode === 'S9999' && response.header.isUnderMaintenance === true
}

const handleWbffErrorResponse = (errorResponse: WbffResponse) => {
  const errorDisplayInfo = errorResponse.error
  const commonStore = useCommonStore()
  const { setIsGlobalWbffErrorHalfSheetVisible, setGlobalWbffError } = commonStore

  setGlobalWbffError(errorDisplayInfo || DEFAULT_ERROR_DISPLAY_INFO)
  setIsGlobalWbffErrorHalfSheetVisible(true)
}

export const get = async <T>(url: string, config?: AxiosRequestConfig) => {
  const wbffResponse = await request<T>({ ...config, method: 'GET', url })
  return handleWbffResponse(wbffResponse)
}

export const post = async <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
  const processedConfig = {
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-CSRF-TOKEN': g.CSRF_TOKEN,
    },
  }
  const wbffResponse = await request<T>({ ...processedConfig, method: 'POST', url, data })
  return handleWbffResponse(wbffResponse)
}

export const put = async <T>(url: string, data?: any, config?: AxiosRequestConfig) => {
  const wbffResponse = await request<T>({ ...config, method: 'PUT', url, data })
  return handleWbffResponse(wbffResponse)
}

export const del = async <T>(url: string, config?: AxiosRequestConfig) => {
  const wbffResponse = await request<T>({ ...config, method: 'DELETE', url })
  return handleWbffResponse(wbffResponse)
}
